<div class="actions">
    <div class="action_btns no_bg d-flex justify-content-between m-0" *ngIf="!locked">
        <i class="fa fa-edit" *ngIf="isEditable" (click)="editEmit.emit();$event.stopPropagation()"></i>
        <i class="fa fa-trash" *ngIf="isDeleteable" (click)="deleteEmit.emit();$event.stopPropagation()"></i>
    </div>
    <div class="locked d-flex no_bg justify-content-center" *ngIf="locked">
        <i class="fa fa-lock" (click)="editEmit.emit();$event.stopPropagation()"></i>
    </div>
</div>